module.exports = __webpack_public_path__ + "static/media/copy.9e0212b4.svg";